import React from 'react';
import { componentService } from 'js/services/component.service';

export const UnsubscribeMarketing = React.lazy(() => import(/* webpackChunkName: "unsubscribe-marketing" */ './UnsubscribeMarketing'));

componentService.registerPageComponents({ 'unsubscribe-marketing': UnsubscribeMarketing });
